import { render, staticRenderFns } from "./all-documents-added-success-message.vue?vue&type=template&id=39937aa5&scoped=true&"
import script from "./all-documents-added-success-message.vue?vue&type=script&lang=js&"
export * from "./all-documents-added-success-message.vue?vue&type=script&lang=js&"
import style0 from "./all-documents-added-success-message.vue?vue&type=style&index=0&id=39937aa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39937aa5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39937aa5')) {
      api.createRecord('39937aa5', component.options)
    } else {
      api.reload('39937aa5', component.options)
    }
    module.hot.accept("./all-documents-added-success-message.vue?vue&type=template&id=39937aa5&scoped=true&", function () {
      api.rerender('39937aa5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/documents/components/all-documents-added-success-message.vue"
export default component.exports